import { DateTime } from 'luxon'
import { Filter } from './types'

// Un procesador toma un valor crudo y devuelve el valor transformado
type FilterProcessor = (value: any) => any

const filterProcessors: Record<string, FilterProcessor> = {
  // Para la fecha inicial: toma “YYYY-MM-DD”, itera al inicio del día
  initialCreatedDate: (dateStr: string) =>
    DateTime.fromISO(dateStr, { zone: 'local' })
      .startOf('day')
      .toUTC()
      .toISO({ suppressMilliseconds: true }),

  // Para la fecha final: toma “YYYY-MM-DD”, lleva al final del día
  finalCreatedDate: (dateStr: string) =>
    DateTime.fromISO(dateStr, { zone: 'local' })
      .endOf('day')
      .toUTC()
      .toISO({ suppressMilliseconds: true })
}

export function processFilters(filters: Filter[]): Filter[] {
  return filters.map((f) => {
    const processor = filterProcessors[f.key]
    return processor ? { ...f, value: processor(f.value) } : f
  })
}
